"use strict";

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");
/** An error emitted by Sentry SDKs and related utilities. */


var SentryError =
/** @class */
function (_super) {
  tslib_1.__extends(SentryError, _super);

  function SentryError(message) {
    var _newTarget = this.constructor;

    var _this = _super.call(this, message) || this;

    _this.message = message; // tslint:disable:no-unsafe-any

    _this.name = _newTarget.prototype.constructor.name;
    Object.setPrototypeOf(_this, _newTarget.prototype);
    return _this;
  }

  return SentryError;
}(Error);

exports.SentryError = SentryError;